import React from 'react';

import CreateTrail from '../../components/trails/CreateTrail';
import PageLayout from '../../components/layout/PageLayout';

const EditTrailPage = () => {
  return (
    <PageLayout>
      <CreateTrail />
    </PageLayout>
  );
};

export default EditTrailPage;
